module.exports = __webpack_public_path__ + "static/img/acne_02.ea3e04e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c13/acne_02.jpg
// module id = iM1u
// module chunks = 1